import React from 'react';
import { IconButton } from '../../../controls/Controls.jsx';
import {
  CreditCardOutlined,
  DeleteOutlined,
  EditOutlined,
  ProductOutlined,
  RedoOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export function EventsListTableSettings({
  event,
  onShowWorkshopsClick,
  onArchiveClick,
  isAdmin,
  isArchived,
  onDetailClick,
  onEditClick,
  onDelete,
}) {
  const { t } = useTranslation();
  return (
    <>
      {onEditClick && isAdmin && !isArchived ? (
        <IconButton
          icon={<EditOutlined />}
          tooltip={t('Upraviť')}
          onClick={(e) => {
            e.stopPropagation();
            onEditClick(event);
          }}
        />
      ) : null}
      {onArchiveClick && isAdmin && isArchived ? (
        <IconButton
          icon={<RedoOutlined />}
          tooltip={t('Obnoviť akciu')}
          onClick={(e) => {
            e.stopPropagation();
            onArchiveClick(event);
          }}
        />
      ) : null}
      {onDetailClick ? (
        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail akcie')}
          onClick={(e) => {
            e.stopPropagation();
            onDetailClick(event);
          }}
        />
      ) : null}
      {onShowWorkshopsClick ? (
        <IconButton
          icon={<ProductOutlined />}
          tooltip={t('Zobraziť zoznam seminárov')}
          onClick={(e) => {
            e.stopPropagation();
            onShowWorkshopsClick(event);
          }}
        />
      ) : null}
      {onArchiveClick && isAdmin && !isArchived ? (
        <IconButton
          icon={<CreditCardOutlined />}
          tooltip={t('Archivovať akciu')}
          onClick={(e) => {
            e.stopPropagation();
            onArchiveClick(event);
          }}
        />
      ) : null}
      {onDelete && isAdmin ? (
        <IconButton
          icon={<DeleteOutlined />}
          tooltip={t('Vymazať')}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(event);
          }}
        />
      ) : null}
    </>
  );
}
